import { render, staticRenderFns } from "./scope35.vue?vue&type=template&id=6aa021f2&scoped=true"
import script from "./scope35.vue?vue&type=script&lang=js"
export * from "./scope35.vue?vue&type=script&lang=js"
import style0 from "./scope35.vue?vue&type=style&index=0&id=6aa021f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa021f2",
  null
  
)

export default component.exports